import React from 'react';
import { LoadingIndicator } from 'react-magma-dom';

export const Loader = () => {
  return (
    <div className="loaderWrapper" >
      <LoadingIndicator />
    </div >
  );
};
